import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private storage = inject(StorageService);
  isLoggedIn: WritableSignal<boolean> = signal<boolean>(this.storage.isAuthenticate());
  isHttpRequest: WritableSignal<boolean> = signal<boolean>(false);
  user: WritableSignal<any> = signal(false)
  globeMap = signal<mapboxgl.Map | undefined>(undefined)

  headerClass: WritableSignal<string> = signal<string>('');
  requests: Array<any> = [];
  currentURL = signal<string>('/');
}
